import { Items } from 'src/app/core/models/common/items.model';

export const CONST = {
  SELECT_DATE: $localize`Select Date`,
  WAREHOUSE_SCAN: $localize`Warehouse Scan`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  ENTER_TRACKING_NUMBER: $localize`Enter or upload Tracking Numbers`,
  FILE_UPLOAD: $localize`File Upload`,
  SUBMIT: $localize`Submit`,
  SELECT: $localize`Select`,
  SORT_CODE: $localize`Sort Code`,
  LOCATION: $localize`Location`,
  LOCATION_PLACEHOLDER: $localize`Enter Location`,
  LOCATION_INVALID_ERROR: $localize`Please enter a valid location`,
  LOCATION_EMPTY_ERROR: $localize`Location cannot be empty`,
  TRACKING_NUMBER_INVALID_ERROR: $localize`Please enter a valid Tracking Number`,
};

export const ColumnText = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  SORT_DATE: $localize`Sort Date`,
  SORT_CODE: $localize`Sort Code`,
  LOCATION: $localize`Location`,
  REASON: $localize`Reason`,
  FLEX: $localize`Flex`,
  STATUS: $localize`Status`,
};
export enum ColumnIds {
  TRACKING_NUMBER = 'trackingNumber',
  SORT_DATE = 'sortDate',
  SORT_CODE = 'sortCode',
  LOCATION = 'location',
  REASON = 'reason',
  FLEX = 'flex',
  STATUS = 'status',
}

export const SORT_OPTIONS: Items[] = [
  { id: 'D1', selected: true },
  { id: 'D3', selected: true },
  { id: 'D9', selected: true },
  { id: 'L1', selected: true },
  { id: 'P1', selected: true },
  { id: 'P4', selected: true },
  { id: 'P7', selected: true },
  { id: 'S1', selected: true },
  { id: 'S7', selected: true },
];

export const SORT_OPTION_LIST = [...SORT_OPTIONS].map((item) => {
  return {
    label: item.id,
    value: item.id,
  };
});
export type WarehouseScan = {
  trackingNumber: string;
  sortDate: string;
  sortCode: string;
  location: string;
  reason: string;
  flex: string;
  status: string;
};

export const MOCK_TABLE_CONSTS: WarehouseScan[] = [
  {
    trackingNumber: '1Z937254729',
    sortDate: 'May 2, 2023',
    sortCode: 'L1',
    location: 'EW',
    reason: 'Lorem',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z1212121212',
    sortDate: 'May 8, 2023',
    sortCode: 'L1',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'COD',
    status: 'Active',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 2, 2023',
    sortCode: 'D1',
    location: 'EW',
    reason: 'Lorem',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z1212121212',
    sortDate: 'May 5, 2023',
    sortCode: 'D3',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z987654321',
    sortDate: 'May 4, 2023',
    sortCode: 'D9',
    location: 'EW',
    reason: 'Lorem',
    flex: 'COD',
    status: 'Active',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 6, 2023',
    sortCode: 'D1',
    location: 'EW',
    reason: 'Lorem',
    flex: 'COD',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 3, 2023',
    sortCode: 'P1',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 8, 2023',
    sortCode: 'P4',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z123456789',
    sortDate: 'May 4, 2023',
    sortCode: 'P4',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'COD',
    status: 'Active',
  },
  {
    trackingNumber: '1Z343434718',
    sortDate: 'May 7, 2023',
    sortCode: 'P7',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z943637654',
    sortDate: 'May 10, 2023',
    sortCode: 'S1',
    location: 'EW',
    reason: 'Lorem',
    flex: 'Security screening required',
    status: 'Not on file',
  },
  {
    trackingNumber: '1Z943637754',
    sortDate: 'May 12, 2023',
    sortCode: 'S7',
    location: 'EW',
    reason: 'Lorem Ipsum',
    flex: 'Security screening required',
    status: 'Active',
  },
];
